var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28333 26H20.7167C21.4214 26 22 25.4254 22 24.7174V12.4196C22 11.7116 21.4271 11.1429 20.7167 11.1429H19.4792V9.34955C19.4792 6.94107 18.551 4.26562 17.0385 2.65223C15.5318 1.03884 13.3719 0 11.0057 0H11H10.9943C8.62813 0 6.46823 1.03884 4.96146 2.64643C3.44896 4.25982 2.52083 6.93527 2.52083 9.34375V11.1429H1.28333C0.572917 11.1429 0 11.7174 0 12.4196V24.7174C0 25.4254 0.572917 26 1.28333 26ZM5.55729 9.34955C5.55729 7.76518 6.12448 5.80357 7.16719 4.68929V4.67188C8.17552 3.59241 9.56771 2.95982 10.9943 2.95982H11.0057C12.4323 2.95982 13.8245 3.59241 14.8328 4.67188V4.68348L14.8271 4.68929C15.8755 5.80357 16.437 7.76518 16.437 9.34955V11.1429H5.55729V9.34955Z",
    fill: "#0876A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.6ea82a0bcc72d18f2a221c7975f6cea6.svg";
export { ForwardRef as ReactComponent };